import axios from "axios";
import { __constants } from "../constants";
const BASE_URL = process.env.REACT_APP_SERVER_URL;

export const getDashBoardAnalyticsController = async () => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/admin/stats-analytics",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        return err.response
    }
}

export const getAnalyticsGraph = async (type) => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/admin/analytic/graph?type=" + type,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        return err.response
    }
}